var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InteractionHandler } from "../../Interactions";
import { Matrix4, Quaternion, Vector3 } from "flavr-math";
import { ButtonType, DropOffMode, Grabbable } from "flavr-common";
import { PickupModelMessage } from "@messages/attachment/AttachmentMessage";
/**
 * This class is responsible to handle the interaction with models that are grabbable
 */
export class GrabbableInteractionHandler extends InteractionHandler {
    constructor(interactionModule) {
        super(Grabbable.typestatic, [Grabbable.typestatic], [], []);
        this.interactionModule = interactionModule;
    }
    getBehaviorDescription() {
        return "Objekt bewegen";
    }
    /// Button press handlers ///
    onSelectButtonPress(params, uid, controller, _hitpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Grabbable.is(params)) {
                const transform = this.interactionModule.getModelTransformation(uid);
                if (transform === undefined)
                    return;
                const originalTransformWorld = new Matrix4();
                // originalTransformWorld.compose(transform.pos, transform.ori, transform.scale)
                originalTransformWorld.compose(new Vector3(0, 0, 0), new Quaternion(0, 0, 0, 1), new Vector3(1, 1, 1));
                const position = [0, 0, 0];
                const orientation = [0, 0, 0, 1];
                const scale = [1, 1, 1];
                this.connection.send(new PickupModelMessage(uid, {
                    controllerUid: controller.uid,
                    offset: { position, orientation, scale },
                    dropOffMode: DropOffMode.ALWAYS,
                    dropOffButton: ButtonType.SELECT,
                    createTemporaryModel: false,
                    dropOnReleaseButton: true,
                }));
            }
        });
    }
}
